import { render, staticRenderFns } from "./NetGsmExtensions.vue?vue&type=template&id=70e00e02&scoped=true"
import script from "./NetGsmExtensions.vue?vue&type=script&lang=js"
export * from "./NetGsmExtensions.vue?vue&type=script&lang=js"
import style0 from "./NetGsmExtensions.vue?vue&type=style&index=0&id=70e00e02&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e00e02",
  null
  
)

export default component.exports